import Basic from "../../media/Work/basic.jpg";
import Boxhunt from "../../media/Work/boxhunt.jpg";
import Camera from "../../media/Work/camera.jpg";
import Portfolio from "../../media/Work/portfolio.jpg";
import Ecommerce from "../../media/Work/ecommerce.jpg";
import Expenses from "../../media/Work/expenses.jpg";
import Information from "../../media/Work/information.jpg";
import Tabs from "../../media/Work/tabs.jpg";
import Todo from "../../media/Work/todo.png";
import Weather from "../../media/Work/weather.png";
import Login from "../../media/Work/login.jpg";



export const projectsData = [
  {
    id: 1,
    image: Boxhunt,
    title: "Box Hunt",
    category: "responsive",
    demo: "https://vyshnavikamineni.github.io/UI-Box-Hunt/",
    repo: "https://github.com/VyshnaviKamineni/UI-Box-Hunt"
  },
  {
    id: 2,
    image: Basic,
    title: "Basic Portfolio",
    category: "react",
    demo: "https://vyshnavikamineni.github.io/portfolio/",
    repo: "https://github.com/VyshnaviKamineni/portfolio"
  },
  {
    id: 3,
    image: Camera,
    title: "Camera & Location Access",
    category: "responsive",
    demo: "https://vyshnavikamineni.github.io/Camera-Access/",
    repo: "https://github.com/VyshnaviKamineni/Camera-Access"
  },
  {
    id: 4,
    image: Ecommerce,
    title: "Ecommerce Website",
    category: "react",
    demo: "https://vyshnavikamineni.github.io/e-commerce/",
    repo: "https://github.com/VyshnaviKamineni/e-commerce"
  },
  {
    id: 5,
    image: Expenses,
    title: "Expense Tracker",
    category: "react",
    demo: "https://vyshnavikamineni.github.io/expense-tracker/",
    repo: "https://github.com/VyshnaviKamineni/expense-tracker"
  },
  {
    id: 6.,
    image: Portfolio,
    title: " My Portfolio",
    category: "react",
    demo: "https://vyshnavikamineni.github.io/Vyshnavi-Portfolio/",
    repo: "https://github.com/VyshnaviKamineni/Vyshnavi-Portfolio",
  },
  {
    id: 7,
    image: Information,
    title: "Information Update",
    category: "react",
    demo: "https://vyshnavikamineni.github.io/before-and-after/",
    repo: "https://github.com/VyshnaviKamineni/before-and-after"
  },
  {
    id: 8,
    image: Tabs,
    title: "Tab Implementation",
    category: "responsive",
    demo: "https://vyshnavikamineni.github.io/Tab-Implementation/",
    repo: "https://github.com/VyshnaviKamineni/Tab-Implementation"
  },
  {
    id: 9,
    image: Todo,
    title: "ToDo List",
    category: "react",
    demo: "https://vyshnavikamineni.github.io/todo-app/",
    repo: "https://github.com/VyshnaviKamineni/todo-app"
  },
  {
    id: 10,
    image: Weather,
    title: "Weather Dashboard",
    category: "react",
    demo: "https://vyshnavikamineni.github.io/weather_dashboard/",
    repo: "https://github.com/VyshnaviKamineni/weather_dashboard" 
  },
  {
    id: 11,
    image: Login,
    title: "Login System Redux",
    category: "react",
    demo: "https://vyshnavikamineni.github.io/Login_System/",
    repo: "https://github.com/VyshnaviKamineni/Login_System"
  }

];


export const projectsNav = [
    {
        name: 'all'
    },
    {
        name: 'react'
    },
    {
        name: 'responsive'
    },
    
];